<template>
  <q-form class="license-state-dialog-container center relative scroller">
    <div class="row items-center icon-container">
      <img
        :src="License_exclamation_icon"
        alt="License-Exclamation-Icon"
      />
    </div>
    <div class="dialog-title text-center">{{ $t('generic.licenseStates.licenseTrialFailure.title') }}</div>
    <div class="dialog-description text-center">
      <div class="gordita-400-16-r">
        <div style="width: 400px; margin-left: 80px">{{ $t('generic.licenseStates.licenseTrialFailure.description') }}</div>
        <br />
        Our
        <a
          href="https://www.incredibuild.com/pricing"
          class="link-font text-brand_almost_black"
          >community version</a
        >
        is free to use forever,<br />
        and there are also
        <a
          href="https://www.incredibuild.com/pricing"
          class="link-font text-brand_almost_black"
          >great packages</a
        >
        available,<br />
        please
        <a
          href="https://www.incredibuild.com/contact-us"
          class="link-font text-brand_almost_black"
          >contact us</a
        >
        for more information
      </div>

      <div class="input-container">
        <q-input
          v-model="licenseKey"
          :data-testid="elementsId.dialogs.licenseDialogs.licenseTrialFailureDialog.licenseKeyInput"
          class="license-key-input"
          label="Enter a different license key"
          bg-color="white"
          outlined
          lazy-rules
          input-class="brand_almost_black"
          no-error-icon
          @keypress="handleKeyPress($event)"
        />
      </div>

      <div class="button-container">
        <q-spinner-dots
          v-if="licensePending"
          class="text-brand_almost_black"
          style="align-items: center"
          size="4em"
        />
        <q-btn
          :data-testid="elementsId.dialogs.licenseDialogs.licenseTrialFailureDialog.submitButton"
          v-else
          flat
          type="submit"
          rounded
          no-caps
          tabindex="3"
          :disabled="!licenseKey"
          :class="{ disabled: !licenseKey }"
          class="submit-button load-key-btn incredi-button-ibx primary-strong enable focus-be-gone"
          :label="$t('generic.licenseStates.loadKey')"
          @click.prevent.stop="submitLicense()"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
import elementsId from '@/const/elementIds.json';
import License_exclamation_icon from '@/assets/images/LicenseStatesDialogs/license-exclamation-icon.svg';
import { defineComponent } from 'vue';
import { licenseDialogMixins } from './licenseDialogMixins';

export default defineComponent({
  name: 'LicenseTrialFailureDialog',
  mixins: [licenseDialogMixins],
  setup() {
    return {
      License_exclamation_icon,
      elementsId,
    };
  },
});
</script>

<style scoped lang="scss">
@import './LicenseDialogsCommonStyle';
</style>
